<template>
	<div class="indextopnav" :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto' }">
		<el-card v-for="(i, idx) in navlist" :key="idx" style="margin:10px 10px 0 10px">
			<div slot="header" class="clearfix">
				<div>
					<el-form :inline="true" style="margin-top:-5px;">
						<el-form-item label-width="10px">
							<span>{{idx + 1}}</span>  
							<i v-if="idx>0" class="el-icon-caret-top" title="上移" @click="moveNav(-1,idx)" style="margin-left:20px;font-size:15pt;color:#ffaa00"></i>
							<i class="el-icon-caret-bottom" title="下移" @click="moveNav(1,idx)" style="margin-left:20px;font-size:15pt;color:#ffaa00"></i>
						</el-form-item>
						<el-form-item label="Guide name :" label-width="180px">
							<el-input type="text" v-model="i.title" size="mini" style="width:280px;margin-left:20px"></el-input>
						</el-form-item>
						<el-form-item label="Select language :" label-width="180px">
							<el-select v-model="i.lang" size="mini" placeholder="" style="width:200px;">
								<el-option :label="item.label" :value="item.value" v-for="(item, index) in langlist" :key="index"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-button type="warning" size="mini" @click="deltopnav(idx)" style="margin-left:20px">remove</el-button>
						</el-form-item>
					</el-form>
					<!-- <i class="el-icon-delete" title="删除" @click="delbanner(index)" style="margin-left:20px"></i> -->
				</div>
			</div>
			<el-row>
				<el-col :span="5" style="min-width:230px;">
					<el-form label-width="5px" size="mini">
						<el-form-item style="padding-left:20px"><label>Select product</label></el-form-item>
						<el-form-item>
							<div class="addcargo" @click="openselectcargo(idx)"><i class="el-icon-plus avatar-uploader-icon"></i></div>
						</el-form-item>
					</el-form>
				</el-col>
				<el-col :span="13">
					<el-row style="margin-top:30px" :gutter="2">
						<el-col :xl="4" :xs="8" :sm="8" :md="6" :lg="5" v-for="(item, index) in i.cargolist" style="padding-left:5px;min-width:200px;margin-top:5px" :key="index">
							<el-card shadow="never" class="box-card imageperview_cargo" :body-style="{ padding: '5px' }">
								<!-- <div slot="header" class="clearfix">
									<div class="headtitle"><i class="el-icon-delete" title="删除" @click="delcargo(idx, index)" style="margin-left:20px"></i></div>
								</div> -->
								<div slot="header" class="clearfix">
									<div class="headtitle">
									<i v-if="index>0" class="el-icon-caret-left" title="左移" @click="movecargo(-1,idx,index)" style="margin-right:30px;font-size:15pt;color:#ffaa00"></i>
									<i class="el-icon-caret-right" title="右移" @click="movecargo(1,idx,index)" style="margin-left:20px;font-size:15pt;color:#ffaa00"></i>
									<i class="el-icon-delete" title="删除" @click="delcargo(idx, index)" style="margin-left:30px"></i></div>
								</div>
								<div class="block cargoimg">
									<el-image :src="item.src">
										<div slot="error" class="image-slot"><i class="el-icon-picture-outline"></i></div>
									</el-image>
								</div>
							</el-card>
						</el-col>
					</el-row>
				</el-col>
			</el-row>
		</el-card>
		<el-row style="margin-top:10px">
			<el-col :span="5">
				<el-form label-width="30px" size="medium">
					<el-form-item><el-button type="primary" @click="addNav" plain>Add guide</el-button></el-form-item>
				</el-form>
			</el-col>
		</el-row>
		<el-row class="footerhandler" v-if="isshow">
			<el-col :span="5" style="color:transparent;">1</el-col>
			<el-col :span="4" class="submitBtn"><div @click="savecargolist">Save</div></el-col>
			<el-col :span="4" class="submitBtn_cancel"><div @click="cancel">Cancel</div></el-col>
		</el-row>
		<!-- <selectcargo ref="selcargo" @addcargorow="surecargo" @closecargo="closecargo"></selectcargo> -->
		<dialogwin ref="dialogwin" @dialogsrue="dialogsrue"></dialogwin>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
// import selectcargo from '@/components/baseinfo/selectcargo';
import dialogwin from '@/components/tools/dialogwin.vue';
export default {
	components: {
		//selectcargo
		dialogwin
	},
	props: {
		urlparam: {
			type: Object,
			default: {}
		}
	},
	data() {
		return {
			windowHeight: window.innerHeight - 150,
			isshow: true,
			cargoparam: {},
			//cargolist:[],
			divclass: 'indextopnav',
			navlist: [{ title: '',lang:'', cargolist: [] }],
			currentindex: -1,
			langlist:[],
			cargotype:''
		};
	},
	mounted() {
		var that = this;
		if(this.urlparam.l_tablename!=undefined)
			this.cargotype=this.urlparam.l_tablename;
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/shop/shopindex.scss');
			that.getindexcargo();
		});
	},
	methods: {
		getindexcargo() {
			var that = this;
			this.isshow = false;
			this.$tool.loading('正在加载', this.divclass);
			this.$apipost.get.GetIndexcargo({ type: 'nav',cargotype:this.cargotype }).then(res => {
				if (res.state == '1') {
					 var list = res.list;
					 that.navlist=[];
					 for(var i=0;i<list.length;i++){
						 that.navlist.push({title:list[i].title,lang:list[i].lang,cargolist:[]});
						 that.getCargoPic(list[i].cargolist,0,i);
					 }
				} else {
					that.isshow = true;
					this.$tool.loadingclose();
				}
				that.GetLanglist();
			}).catch(e=>{
				that.getindexcargo();
			});
		},
		GetLanglist(){
			//debugger
			var that = this;
			this.$apipost.get.dic({ type: '语言类型' }).then(res => {
				//console.log('list',res.list);
				if (res.list != undefined) {
					that.langlist=res.list;
				}
			}).catch(e=>{
				that.GetLanglist();
			});
		},
		addNav() {
			this.navlist.push({ title: '',lang:'', cargolist: [] });
		},
		delcargo(idx, index) {
			this.navlist[idx].cargolist.splice(index, 1);
			if(this.navlist.length==0)
				this.addNav();
		},
		movecargo(type,index,idx){
			//debugger
			if(type<0)//左移
			{
				if(idx>0)
					this.Move(this.navlist[index].cargolist,idx,parseInt(idx)-1);
			}
			else//右移
			{
				if(idx<this.navlist[index].cargolist.length-1)
					this.Move(this.navlist[index].cargolist,idx,parseInt(idx)+1);
			}
		},
		Move(arr, index1, index2) {
			arr[index1] = arr.splice(index2, 1, arr[index1])[0];
			return arr;
		},
		//移动导航
		moveNav(type,index){
			//debugger
			if(type<0)//上移
			{
				if(index>0)
					this.Move(this.navlist,index,parseInt(index)-1);
			}
			else//下移
			{
				if(index<this.navlist.length-1)
					this.Move(this.navlist,index,parseInt(index)+1);
			}
		},
		//选择商品
		selectcargo(idx) {
			var that = this;
			that.currentindex = idx;
			that.cargoparam = {
				type: 'select',
				searchparam: '',
				cargotype:this.cargotype
			};
			if (that.$refs.selcargo != undefined) that.$refs.selcargo.init(that.cargoparam);
		},
		//确认选择
		surecargo(e) {
			//debugger;
			var that = this;
			var rows = [];
			if (e.rows.length > 0) {
				//判断是否与已添加的商品重复，有重复的则不显示了
				e.rows.forEach(s => {
					var isexists = false;
					that.navlist[that.currentindex].cargolist.forEach(c => {
						if (c.linkvalue == s.pkcno) {
							isexists = true;
							return false;
						}
					});
					if (!isexists) rows.push(s);
				});
			}
			if (rows.length > 0) {
				//获取商品图片,再回填到列表上
				this.$tool.loading('正在加载', this.divclass);
				this.getCargoPic(rows, 0);
			}
		},
		//获取商品图片
		getCargoPic(rows, index,i) {
			var that = this;
			var currentindex=that.currentindex;
			if(i!=undefined){
				currentindex=i;
			}
			//debugger
			if (rows.length > index) {
				var id = rows[index].linkvalue;
				if (id == undefined) id = rows[index].pkcno;
				this.$apipost.get.GetCargoPic({ pkcno: id, type: 1,isweb:1 }).then(res => {
					if (res.state == '1') {
						var src = '';
						if (res.search_pic != undefined) src =decodeURIComponent(res.search_pic.src) ;
						that.navlist[currentindex].cargolist.push({ linkvalue: id, src: src });
					}
					index = parseInt(index) + 1;
					that.getCargoPic(rows, index,i);
				});
			} else {
				this.$tool.loadingclose();
				that.isshow = true;
				//this.$refs.selcargo.showcargo = false;
			}
		},
		//保存商品设置
		savecargolist() {
			var that = this;
			if (this.navlist.length == 0) {
				this.$tool.message('请添加导航', 0);
				return false;
			} else {
				var iserror = false;
				var index = 0;
				this.navlist.forEach(e => {
					index++;
					if (e.title.replace(/ /g, '') == '') {
						iserror = true;
						this.$tool.message("Please fill the No." + index + "'s guide name", 0);
					}
					if(!iserror){
						if (e.lang.replace(/ /g, '') == '') {
							iserror = true;
							this.$tool.message("Please fill the No." + index + "'s language", 0);
						}
					}
					if (!iserror) {
						if (e.cargolist.length == 0) {
							iserror = true;
							this.$tool.message("Please select a product for the No." + index + "'s", 0);
						}
					}
					if (iserror) return false;
				});
				if (iserror) return false;
			}
			var list = JSON.parse(JSON.stringify(this.navlist));
			list.forEach(e => {
				e.cargolist.forEach(c => {
					c.src = '';
				});
			});
			
			var paraminfo = {
				navlist: list,
				type: 'nav',
				linktype: 'cargo',
				cargotype:this.cargotype
			};
			this.$tool.loading('正在保存', this.divclass);
			that.isshow = false;
			// console.log('nav',encodeURIComponent(JSON.stringify(paraminfo)));
			// return false;
			this.$apipost.post.SaveIndexCargo({ paraminfo: paraminfo }).then(res => {
				that.isshow = true;
				this.$tool.loadingclose();
				if (res.state == '1') {
					this.$tool.message('保存成功', 1);
					setTimeout(function() {
						that.cancel();
					}, 1000);
				} else this.$tool.message(res.message, 0);
			}).catch(e=>{
				that.savecargolist();
			});
		},
		deltopnav(index){
			this.navlist.splice(index,1);
		},
		//关闭选择窗口
		closecargo() {
			this.$refs.selcargo.showcargo = false;
		},
		cancel() {
			Utils.$emit('handleRermove', localStorage.getItem('tabname'));
		},
		openselectcargo(idx){
			var that=this;
			that.currentindex = idx;//每个轮播图中的索引,比如中文轮播图传了三张图片，选择其中一张轮播图进行设置商品
			this.$apipost.get.GetLinkInfo({ l_id:576 }).then(res => {
				//debugger
				if (res.info != undefined) {
					var paramitem=res.info;
					paramitem.iswin=true;
					that.$refs.dialogwin.init({item:paramitem,title:'选择商品'});
				} else that.$tool.message('此功能无法启用', 0);
			});
		},
		dialogsrue(e){
			//debugger
			var that = this;
			var rows = [];
			if(e.l_id==576){
				if(e.rows!=undefined)
				{
					if (e.rows.length > 0) {
						//判断是否与已添加的商品重复，有重复的则不显示了
						e.rows.forEach(s => {
							var isexists = false;
							that.navlist[that.currentindex].cargolist.forEach(c => {
								if (c.linkvalue == s.pkcno) {
									isexists = true;
									return false;
								}
							});
							if (!isexists) rows.push(s);
						});
					}
					if (rows.length > 0) {
						//获取商品图片,再回填到列表上
						this.$tool.loading('正在加载', this.divclass);
						this.getCargoPic(rows, 0);
					}
				}
			}
		}
	}
};
</script>

<style></style>
